import { readUnhandledEnumCase } from 'rpc-client-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { View } from 'foundations-components/transitional/components/View';
import AIGeneratedContentBanner from '../../learningContent/components/AIGeneratedContentBanner';
import { ExternalLearningContentBanner } from '../../learningContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShortContentDetails = ({
  short: {
    contentId,
    description,
    subCategories,
    hubId,
    visibility
  }
}) => {
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(ExternalLearningContentBanner, {
      contentVisibility: visibility,
      hubId: hubId,
      marginBlockEnd: "800"
    }), /*#__PURE__*/_jsx(AIGeneratedContentBanner, {
      contentId: contentId,
      hubId: hubId,
      marginBlockEnd: "800"
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shortContent.descriptionHeader"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: description
    }), /*#__PURE__*/_jsx(Flex, {
      columnGap: "400",
      flexWrap: "wrap",
      rowGap: "200",
      children: subCategories.map(subCategory => /*#__PURE__*/_jsx(Tag, {
        inline: true,
        margin: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyCategories.${readUnhandledEnumCase(subCategory)}`
        })
      }, subCategory))
    })]
  });
};
export default ShortContentDetails;